import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledCardsContainer, StyledTableContainer } from './KindergartenReestrStyle';
import './KindergartenReestrTranslate';
import paths from '../../_helpers/paths';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearState,
  kindergartenReestrModule,
  loadKindergartens
} from './KindergartenReestrDucks';
import { requestsColumns } from './TableColumns/TableColumns';
import Counters from './KindergartenReestrComponents/Counters/Counters';
import Filters from './KindergartenReestrComponents/Filters/Filters.jsx';
import { getKindergartenCounter } from './KindergartenReestrComponents/Counters/CountersDucks';
import useTableFilter from '../../components/TableFilter/useTableFilter';
import StaticTablePaginated from '../../_ui/Table/StaticTablePaginated';
import Search from './KindergartenReestrComponents/Search/Search';
import i18n from 'i18next';
import { useLocation, useParams } from 'react-router-dom';
import DialogComponent from '../../components/DialogComponent/DialogComponent';
import useModal from '../../modules/_hooks/useModal';
import { addListWaiting, changeDUO } from '../VoucherWaitingList/VoucherWaitingListDucks';

function KindergartenReestr() {
  const { t } = useTranslation();
  const { voucherId } = useParams();
  const dispatch = useDispatch();
  let lang = i18n.language;
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const isChangeDuo = searchParams.get('isChangeDuo');
  const type = searchParams.get('type');
  const breadCrumbItems = [];
  breadCrumbItems.push({ name: t('home_subtitle'), href: paths.homePage });
  breadCrumbItems.push({
    name: type === 'SC'
      ? t('kindergarten_org_subtitle')
      : t('kindergarten_subtitle'),
    href: paths.kindergartenServices
  });
  breadCrumbItems.push({
    name: t(type === 'SC' ? 'kindergarten_reestr_org_subtitle' : 'kindergarten_reestr_subtitle')
  });

  const kindergartens = useSelector(state => state[kindergartenReestrModule].data);
  const pageNumber = useSelector(state => state[kindergartenReestrModule].pageNumber);
  const totalElements = useSelector(
    state => state[kindergartenReestrModule].totalElements
  );
  const loading = useSelector(state => state[kindergartenReestrModule].loading);
  const modalAddListWaiting = useModal('addListWaiting');
  const loadData = filter => {
    dispatch(loadKindergartens(filter, t, type));
    dispatch(
      getKindergartenCounter(
        { ...filter, availabilitySo: filter.availableSuo },
        t,
        type
      )
    );
  };
  const handleDone = async () => {
    if (isChangeDuo) {
      dispatch(
        changeDUO(modalAddListWaiting.data.id, modalAddListWaiting, Number(voucherId),type)
      );
    } else {
      dispatch(
        addListWaiting(
          modalAddListWaiting.data.id,
          modalAddListWaiting,
          Number(voucherId),
          type
        )
      );
    }
  };

  const { filter, toPage, changePageSize, searchByFilter } = useTableFilter(
    loadData,
    '',
    { pageNumber: 1, pageSize: 10 }
  );

  useEffect(() => {
    dispatch(clearState());
  }, [dispatch]);

  return (
    <div className="mb3 mt3" style={{ width: '100%' }}>
      <BreadCrumbs items={breadCrumbItems} />
      <StyledCardsContainer>
        <Filters loading={loading} filter={filter} searchByFilter={searchByFilter} />
        <div>
          <Counters type={type} />
          <Search loading={loading} searchByFilter={searchByFilter} />
          {kindergartens && (
            <StyledTableContainer>
              <div className="mt2">
                <StaticTablePaginated
                  TheadComponent={_ => null}
                  pageNumber={pageNumber}
                  loading={loading}
                  data={kindergartens}
                  totalElements={totalElements}
                  changePageSize={changePageSize}
                  pageSizes={[10, 20, 50, 100]}
                  columns={requestsColumns({ t, lang, voucherId, modalAddListWaiting })}
                  filterable={false}
                  pagePagination={page => {
                    if (page !== pageNumber) {
                      toPage(page);
                    }
                  }}
                />
              </div>
            </StyledTableContainer>
          )}
        </div>
        <DialogComponent
          modalTitle={t('kindergarten_reestr_add_waitingList_modalTitle')}
          modalBody={t(
            type === 'SC'
              ? 'kindergarten_reestr_add_waitingList_org_modalBody'
              : 'kindergarten_reestr_add_waitingList_modalBody'
          )}          open={modalAddListWaiting.isOpen}
          handleClose={modalAddListWaiting.close}
          handleDone={handleDone}
        />
      </StyledCardsContainer>
    </div>
  );
}

export default KindergartenReestr;
